export function isPrivateAppleRelayEmailAddress(value: string): boolean {
  return value.includes('@privaterelay.appleid.com');
}
